import React, { useState } from "react";
import { SEC_DataApiPost } from "../../func.js";
import "./NoteInputComponent.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiSave3Fill } from "react-icons/ri";
import { CgSpinner } from "react-icons/cg";

export function NoteInputComponent({ requestId, url, updateApiCallFunction, setActiveOption }) {
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [postApiErrorState, setPostApiErrorState] = useState(false);

  async function addNote() {
    if (!note.trim()) return;
    if (isLoading) return; // Prevent multiple clicks

    setIsLoading(true);
    setPostApiErrorState(false);

    try {
      let formData = { "requestId": requestId, "note": note };
      const response = await SEC_DataApiPost(url, formData, formData, () => setPostApiErrorState(true));
      console.log(response);

      if (response && response.ResponseMetadata.HTTPStatusCode === 200) {
        toast.success("✅ Note added to request!", { autoClose: 3000, position: "top-right" });
        updateApiCallFunction(requestId);
        setIsLoading(false);
        setNote("");
        setActiveOption(null);
      } else {
        toast.error("❌ Failed to add note. Please try again.", { autoClose: 3000, position: "top-right" });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error adding note", error);
      toast.error("❌ Failed to add note. Please try again.", { autoClose: 3000, position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="note-input-container">
      <textarea
        className="note-input-text-area"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Enter your note here..."
        disabled={isLoading} // Disable input while loading
      />
      <button onClick={addNote} disabled={isLoading} className="note-save-button">
        {isLoading ? <span className="loading-spinner"><CgSpinner className="spinner" color="white" /></span> : <RiSave3Fill className="note-save-icon" color="white" />}
      </button>
    </div>
  );
}
